import React, { useEffect, useState } from "react";
import Navbar from "../components/Navbar";
import api from "../api/client";
import { BarChart3, Eye, Bookmark, Handshake, CheckCircle2 } from "lucide-react";

function Stat({ icon: Icon, label, value }) {
    return (
        <div className="bg-ink-200/60 border border-white/10 rounded-sm p-6">
            <div className="flex items-center gap-2 text-silver-400 text-[11px] tracking-[0.3em] uppercase mb-4">
                <Icon className="w-3.5 h-3.5" /> {label}
            </div>
            <div className="font-display text-4xl md:text-5xl silver-text">{value}</div>
        </div>
    );
}

export default function CreatorAnalytics() {
    const [data, setData] = useState(null);

    useEffect(() => {
        (async () => {
            try {
                const r = await api.get("/analytics/creator");
                setData(r.data);
            } catch (_) {}
        })();
    }, []);

    if (!data) return (
        <div className="min-h-screen bg-ink-300 text-silver-100">
            <Navbar />
            <div className="max-w-[1400px] mx-auto px-4 md:px-10 pt-14 text-silver-500">Loading analytics…</div>
        </div>
    );

    return (
        <div className="min-h-screen bg-ink-300 text-silver-100">
            <Navbar />
            <section className="max-w-[1400px] mx-auto px-4 md:px-10 pt-14 pb-28">
                <div className="flex items-center gap-3 mb-3 text-[11px] tracking-[0.3em] text-silver-400 uppercase">
                    <BarChart3 className="w-4 h-4" /> Creator · Intelligence
                </div>
                <h1 className="font-display text-5xl md:text-6xl leading-none mb-12">
                    Your <span className="silver-text italic">funnel.</span>
                </h1>

                <div className="grid grid-cols-2 md:grid-cols-4 gap-5 mb-14" data-testid="analytics-totals">
                    <Stat icon={Eye} label="Total views" value={data.totals.views.toLocaleString()} />
                    <Stat icon={Bookmark} label="Watchlists" value={data.totals.watchlists.toLocaleString()} />
                    <Stat icon={Handshake} label="Offers / deals" value={data.totals.offers.toLocaleString()} />
                    <Stat icon={CheckCircle2} label="Closed" value={data.totals.closed.toLocaleString()} />
                </div>

                <div className="text-xs tracking-[0.3em] uppercase text-silver-400 mb-5">Per-film breakdown</div>
                <div className="overflow-x-auto border border-white/10 rounded-sm">
                    <table className="w-full text-sm" data-testid="analytics-table">
                        <thead className="text-left text-[11px] tracking-widest uppercase text-silver-500 border-b border-white/10">
                            <tr>
                                <th className="p-4">Film</th>
                                <th className="p-4 text-right">Views</th>
                                <th className="p-4 text-right">Watchlists</th>
                                <th className="p-4 text-right">Offers</th>
                                <th className="p-4 text-right">Closed</th>
                            </tr>
                        </thead>
                        <tbody>
                            {data.films.map((f) => (
                                <tr key={f.film_id} className="border-b border-white/5 hover:bg-white/5">
                                    <td className="p-4">{f.title}</td>
                                    <td className="p-4 text-right">{f.views}</td>
                                    <td className="p-4 text-right">{f.watchlists}</td>
                                    <td className="p-4 text-right">{f.offers}</td>
                                    <td className="p-4 text-right">{f.closed}</td>
                                </tr>
                            ))}
                            {data.films.length === 0 && (
                                <tr><td colSpan={5} className="p-6 text-silver-500 text-center">No films yet.</td></tr>
                            )}
                        </tbody>
                    </table>
                </div>
            </section>
        </div>
    );
}
